export enum Role {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER-ADMIN',
}
